import {
  AsyncAccountInfo,
  AsyncAddProduct,
  AsyncBlockedWordListWrapper,
  AsyncCreateAccount,
  AsyncCreateUser,
  AsyncEventAnalytics,
  AsyncEventCustomize,
  AsyncEventDetail,
  AsyncEventList,
  AsyncExternalPreview,
  AsyncGlobalPage,
  AsyncGlobalPageAdmin,
  AsyncListUsers,
  AsyncLiveEdit,
  AsyncLogin,
  AsyncNewEvent,
  AsyncProductDetail,
  AsyncProductList,
  AsyncSelectAccount,
  AsyncSetPlan,
  AsyncTwoStepVerification,
  AsyncUnderDevelopment,
  CollectionDetail,
  CollectionList,
} from 'app/pages';
import { Navigate } from 'react-router-dom';
import { AppModule, AppRoute } from 'types';

export const authRouteList: AppRoute[] = [
  { path: '/login', element: <AsyncLogin /> },
  {
    path: '/auth-two-step-verification',
    element: <AsyncTwoStepVerification />,
  },
  { path: '/select-account', element: <AsyncSelectAccount /> },
];

export const liveShoppingRouteList: AppRoute[] = [
  {
    path: '/',
    element: <Navigate to="/events" replace />,
  },
  {
    path: '/events',
    element: <AsyncEventList />,
    module: AppModule.LIVE_SHOPPING,
    menu: { icon: 'bx bx-calendar-event', title: 'LiveShopping.Events.Title' },
  },
  {
    path: '/events/new',
    element: <AsyncNewEvent />,
    module: AppModule.LIVE_SHOPPING,
  },
  {
    path: '/events/:eventId/edit',
    element: <AsyncNewEvent />,
    module: AppModule.LIVE_SHOPPING,
  },
  {
    path: '/events/:eventId/details',
    element: <AsyncEventDetail />,
    module: AppModule.LIVE_SHOPPING,
  },
  {
    path: '/events/:eventId/analytics',
    element: <AsyncEventAnalytics />,
    module: AppModule.LIVE_SHOPPING,
  },
  {
    path: '/blocked-word-list',
    element: <AsyncBlockedWordListWrapper />,
    module: AppModule.LIVE_SHOPPING,
    menu: {
      icon: 'bx bx-list-ul',
      title: 'LiveShopping.BlockedWordList.Title',
    },
  },
];

export const productRouteList: AppRoute[] = [
  {
    path: '/products',
    element: <AsyncProductList />,
    module: AppModule.PRODUCTS,
    menu: { title: 'Products.List.Title' },
  },
  {
    path: '/products/add',
    element: <AsyncAddProduct />,
    module: AppModule.PRODUCTS,
    menu: { title: 'Products.Create.Title' },
  },
  {
    path: '/products/:productId',
    element: <AsyncProductDetail />,
    module: AppModule.PRODUCTS,
  },
  {
    path: '/product-collections',
    element: <CollectionList />,
    module: AppModule.PRODUCTS,
    menu: { title: 'ProductCollections.List.Title' },
  },
  {
    path: '/product-collections/:collectionId',
    element: <CollectionDetail />,
    module: AppModule.PRODUCTS,
  },
];

export const globalPageAdminRouteList: AppRoute[] = [
  {
    path: '/global-page-admin',
    element: <AsyncGlobalPageAdmin />,
    module: AppModule.LIVE_SHOPPING,
    enableUsingFeaturePlan: 'globalPage',
    menu: { icon: 'bx bx-world', title: 'LiveShopping.GlobalPage.Title' },
  },
  {
    path: '/global-page-admin/edit-live/:eventId',
    element: <AsyncLiveEdit />,
    module: AppModule.LIVE_SHOPPING,
  },
];

export const accountManagementRouteList: AppRoute[] = [
  {
    path: '/users',
    element: <AsyncListUsers />,
    module: AppModule.USERS,
    menu: { icon: 'bx bx-user', title: 'Users.Title' },
  },
  { path: '/users/new', element: <AsyncCreateUser />, module: AppModule.USERS },
  {
    path: '/account-info',
    element: <AsyncAccountInfo />,
    module: AppModule.ACCOUNT_MANAGEMENT,
    menu: { icon: 'bx bx-cog', title: 'Menu.Spended' },
  },
  { path: '/set-plan', element: <AsyncSetPlan /> },
];

export const publicRouteList: AppRoute[] = [
  ...authRouteList,
  { path: '/events/customize', element: <AsyncEventCustomize /> },
  {
    path: '/events/preview',
    element: <AsyncExternalPreview />,
    module: AppModule.LIVE_SHOPPING,
  },
  {
    path: '/global-page/*',
    element: <AsyncGlobalPage />,
    module: AppModule.LIVE_SHOPPING,
  },
  {
    path: '/global-page-admin/:account',
    element: <AsyncGlobalPageAdmin />,
    module: AppModule.LIVE_SHOPPING,
  },
  {
    path: '/global-page-admin/:account/edit-live/:eventId',
    element: <AsyncLiveEdit />,
    module: AppModule.LIVE_SHOPPING,
  },
  { path: '/create-account', element: <AsyncCreateAccount /> },
];

export const authProtectedRouteList: AppRoute[] = [
  ...liveShoppingRouteList,
  ...productRouteList,
  ...globalPageAdminRouteList,
  ...accountManagementRouteList,
  { path: '/underdevelopment', element: <AsyncUnderDevelopment /> },
];
